import { useTranslation } from 'react-i18next';
import { TacticCardConfig } from './MiViewTacticCard.types';

const useMiViewTacticCardConfig = (
) => {
  const { t } = useTranslation();

  const tacticCardConfig: TacticCardConfig = {
    menuList: [
      {
        label: t('maya_miview_menu_item_action'),
      },
    ],
  };

  return { tacticCardConfig };
};

export default useMiViewTacticCardConfig;
